import auth from "./auth";
import api from "./api";

// const BASE_SERVICE_URL = "transactions-service";
// const BASE_SERVICE_URL = "";

export default {
    getList(page, filter) {
        return new Promise((resolve, reject) => {
            api.post(
                "customer-service/cms/customer/key-accounts/list/" + page,
                filter,
                auth.getHeader()
            )
                .then(response => {
                    return resolve(response);
                })
                .catch((status, error) => {
                    console.log(error);
                    reject(status, error);
                });
        });
    },
    updateCompanyCode(param) {
        return new Promise((resolve, reject) => {
            api.post(
                "customer-service/cms/customer/company-code/update",
                param,
                auth.getHeader()
            )
                .then(response => {
                    return resolve(response);
                })
                .catch((status, error) => {
                    reject(status, error);
                });
        });
    },
    updateCompanyCodeStatus(param) {
        return new Promise((resolve, reject) => {
            api.post(
                "customer-service/cms/customer/company-code/status/update",
                param,
                auth.getHeader()
            )
                .then(response => {
                    return resolve(response);
                })
                .catch((status, error) => {
                    reject(status, error);
                });
        });
    },
    getKeyAccountsOptions() {
        return new Promise((resolve, reject) => {
            api.get(
                "customer-service/cms/customer/key-accounts/options",
                auth.getHeader()
            )
                .then(response => {
                    return resolve(response);
                })
                .catch((status, error) => {
                    console.log(error);
                    reject(status, error);
                });
        });
    }
};
